module.exports = __webpack_public_path__ + "230eccfabe77a39fe438754c94496eb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/16_CC_V_Helicopter.png
// module id = 117
// module chunks = 0